exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-c81ff0e2],.v-dialog .v-card__text[data-v-c81ff0e2]{padding:0!important}.v-dialog .v-alert[data-v-c81ff0e2]{border-radius:0!important}.v-dialog[data-v-c81ff0e2],.v-dialog .v-card__text[data-v-c81ff0e2]{overflow:hidden!important}.v-card__actions[data-v-c81ff0e2]{justify-content:flex-end}.confirm-text[data-v-c81ff0e2]{font-size:16px}", ""]);

// exports
